mutation completeProject($input: CompleteProjectInput!) {
	completeProject(input: $input) {
		shopifyProductVariantId
		customProperties {
			name
			value
		}
	}
}